<div class="top_cont">
  <div class="mobile_space">
    <header  >
      <div class="wrap clrfx">
        <a routerLink="/" class="logo left"></a>
        <button class="account-button" mat-button [matMenuTriggerFor]="menu">
          <div class="ico"></div>
          <div class="text">{{ 'Sections.Header.AccountText'| translate }}</div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item
                  (click)="changePasswordClick($event)"
                  *ngIf="!isUserHasAssociations">
            {{ 'Sections.Header.ChangePasswordText'| translate }}
          </button>
          <button mat-menu-item
                  (click)="logoutClick($event)">
            {{ 'Sections.Header.LogoutText'| translate }}
          </button>
        </mat-menu>
      </div>
    </header>
  </div>
</div>
